import React from "react";
import { Route, Switch } from "react-router-dom";
import { IndexHome } from "./Home/indexHome";
import "./index.css";
import {indexMobile} from "./Mobile/indexMobile";

function App() {
  return (
    <Switch>
        {
            <Route exact path="/" component={window.innerWidth < 769 ? indexMobile :IndexHome } />
        }
    </Switch>
  );
}

export default App;
